import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/pages/Home.vue'
import Integration from '@/views/pages/Integration.vue'
import NotFound from "@/views/pages/NotFound.vue";
import Registration from "@/views/pages/Registration.vue";
import DemoRegistration from "@/views/pages/DemoRegistration.vue";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/i/:code',
    name: 'Integration',
    component: Integration
  },
  {
    path: '/reg',
    name: 'Registration',
    component: Registration
  },
  {
    path: '/demo/reg',
    name: 'Demo Registration',
    component: DemoRegistration
  },
  {
    path: "*",
    component: NotFound,
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/pages/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
